(function () {
  class SideMenu extends PIXI.Container {
    constructor(screenMaskId, closeButtonId) {
      super();

      this._screenMaskId = screenMaskId;
      this._closeButtonId = closeButtonId;

      this._settingsOpen = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe("game:sideMenuOpen", this.onSideMenuOpen.bind(this));
      messageBus.subscribe(
        "game:sideMenuClosed",
        this.onSideMenuClosed.bind(this)
      );
      messageBus.subscribe("ui:modal", this.onUIModal.bind(this));
      messageBus.subscribe("game:modal", this.onModal.bind(this));

      this.visible = false;
    }

    initialise() {
      this._dimScreen = resourceManager.get(this._screenMaskId);
      this._dimScreen.interactive = true;

      this._bg = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:bg",
      );
      this._closeButton = resourceManager.get(this._closeButtonId);
      this._homeButton = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:home",
      );
      this._historyButton = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:history",
      );
      this._settingsButton = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:settingsMenu",
      );
      this._gameRulesButton = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:gameRules",
      );
      this._optionsButton = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:options",
      );
      this._fullscreenButton = resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:fullscreenButton",
      );

      this._historyButton.visible = this._activeButtons.btnHistory.visible;
      this._optionsButton.visible = this._activeButtons.btnInfo.visible;
      this._settingsButton.visible = this._activeButtons.btnSettings.visible;
      this._gameRulesButton.visible = this._activeButtons.btnRules.visible;

      this.configureLayout();

      this._closeButton.mousedown = this._closeButton.touchstart = function () {
        messageBus.postImmediate("game:sideMenuClosed", {});
        messageBus.postImmediate("game:settingMenuClosed", {});
      };
      this._dimScreen.mousedown = this._dimScreen.touchstart = function () {
        messageBus.postImmediate("game:sideMenuClosed", {});
        messageBus.postImmediate("game:settingMenuClosed", {});
      };
    }

    onGameConfigEvent(config) {
      this._activeButtons = config.data.uiElements;

      helpPageManager.config = config.data.slotConfig;

      if (!gdk.getPlatformAllowsSplashScreen()) {
        if (game.checkShouldShowPaytableAfterSplash()) {
          resourceManager.get('helpPageScroll').open();
        }
      }

      /*this._activeButtons.btnInfo.visible = false;
            this._activeButtons.btnSettings.visible = false;
            this._activeButtons.btnFullscreen.visible = false;
            this._activeButtons.btnRules.visible = false;*/

      //this._activeButtons.btnHistory.visible = true;

      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:history:highlight",
      ).visible = false;

      this.initialise();
    }

    configureLayout() {
      const buttonYoffset = 92;
      let currentButtonY = 250;

      const buttons = [
        this._homeButton,
        this._historyButton,
        this._settingsButton,
        this._gameRulesButton,
        this._optionsButton,
        this._fullscreenButton,
      ];
      const conditions = [
        this._activeButtons.btnHome,
        this._activeButtons.btnHistory.visible,
        this._activeButtons.btnSettings.visible &&
          this._activeButtons.btnSound.visible,
        this._activeButtons.btnRules.visible,
        this._activeButtons.btnInfo.visible,
        this._activeButtons.btnFullscreen.visible,
      ];

      let numOfButtonsHidden = 0;
      for (let i = 0; i < buttons.length; i++) {
        if (conditions[i]) {
          buttons[i].visible = true;
          buttons[i].position.setY(currentButtonY);
          currentButtonY -= buttonYoffset;
        } else {
          buttons[i].visible = false;
          numOfButtonsHidden++;
        }
      }

      let bgYScaleAndPos = { scale: 1, pos: -80 };
      switch (numOfButtonsHidden) {
        case 5:
          bgYScaleAndPos = { scale: 0.22, pos: 230 };
          break;
        case 4:
          bgYScaleAndPos = { scale: 0.37, pos: 180 };
          break;
        case 3:
          bgYScaleAndPos = { scale: 0.53, pos: 138 };
          break;
        case 2:
          bgYScaleAndPos = { scale: 0.69, pos: 95 };
          break;
        case 1:
          bgYScaleAndPos = { scale: 0.85, pos: 50 };
          break;
        case 0:
        default:
          break;
      }

      const areAllButtonsHidden = numOfButtonsHidden === buttons.length;
      if (numOfButtonsHidden > 0 && !areAllButtonsHidden) {
        this._bg.position.setY(bgYScaleAndPos.pos);
        this._bg.scale.set(1, bgYScaleAndPos.scale);
        this._closeButton.position.setY(currentButtonY + buttonYoffset - 57);
      }
    }

    onSideMenuOpen() {
      if (this._dimScreen !== undefined) {
        this._dimScreen.show(true, 1);
      }
      this._closeButton.interactive = true;
      this.visible = true;
      messageBus.post("game:modal", { reason: "Side Menu Open" });
    }

    onSideMenuClosed() {
      if (this._dimScreen !== undefined) {
        this._dimScreen.show(false);
      }
      this._closeButton.interactive = false;
      this.visible = false;
      messageBus.post("game:modal", {});
    }

    onUIModal(event) {
      switch (event.reason) {
        case "History open": {
          resourceManager.get(
            "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:history:highlight",
          ).visible = true;
          this._settingsOpen = true;
          break;
        }
      }
    }

    onModal(event) {
      if (event.reason === undefined || event.reason === "") {
        if (this._settingsOpen) {
          this._settingsOpen = false;
          resourceManager.get(
            "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:history:highlight",
          ).visible = false;
          messageBus.postImmediate("game:sideMenuClosed", {});
        }
        // activating golden bet forces us out of modal on the stake change - catch this here
        // if the settings dialog is open - not post is used here to ensure this is actioned in the correct order
        if (resourceManager.get("settingsMenu").visible) {
          messageBus.post("game:modal", { reason: "Settings menu open" });
        } else if (this._settingsOpen) {
          this._settingsOpen = false;
          resourceManager.get(
            "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:history:highlight",
          ).visible = false;
          messageBus.postImmediate("game:sideMenuClosed", {});
        }
      }
    }
  }

  var sideMenuCreator = function (json) {
    return new SideMenu(json.screenMaskId, json.closeButtonId);
  };

  var sideMenuInitialiser = function (json) {};

  var sideMenuFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "sideMenu",
    sideMenuCreator,
    sideMenuInitialiser,
    sideMenuFilesRequired
  );
})();
